// The Library's fixed lists and limits (plan 2E Assumptions 1 and 2, R1, R2).

/** In the order the knowledge base shows them. */
export const KB_CATEGORIES = ['Mechanics & bugs', 'Guides & SOPs', 'Ships & loadouts', 'Locations & routes', 'Org info', 'Other'] as const;

/** The only category with a status and a patch. */
export const MECHANICS = KB_CATEGORIES[0];

/** What a new entry starts as. */
export const DEFAULT_CATEGORY = KB_CATEGORIES[1];

export const NOTE_STATUS = [
  { value: 'rumored', label: 'Rumored' },
  { value: 'verify', label: 'Verify on PTU' },
  { value: 'reproduced', label: 'Reproduced' },
  { value: 'fixed', label: 'Fixed' },
] as const;

export const REPORT_TYPES = [
  { type: 'aar', label: 'After-action', hint: 'Crew, haul, results and log from an op' },
  { type: 'haul', label: 'Acquisition haul', hint: 'What acquisition ops brought in, last 30 days' },
  { type: 'battle', label: 'Battle usage', hint: 'What Sierra used supporting fleet ops, last 30 days' },
  { type: 'supply', label: 'Supply status', hint: 'Stockpile and ship cargo, low items flagged' },
  { type: 'readiness', label: 'Ship readiness', hint: 'Each Sierra ship against its prep levels' },
  { type: 'scorecard', label: 'Contribution scorecard', hint: 'Ops, donations and refinery runs per member' },
  { type: 'donors', label: 'Donor thanks', hint: 'Who donated what, for a shout-out post' },
  { type: 'schedule', label: 'Ops schedule', hint: 'Upcoming ops with local times' },
  { type: 'attendance', label: 'Attendance', hint: 'Who flew with Sierra, last 30 days' },
  { type: 'intel', label: 'Intel', hint: 'Sighting or threat report' },
  { type: 'incident', label: 'Incident', hint: 'Losses, griefing, bugs that cost us' },
] as const;

export const LIMITS = {
  title: 200,
  patch: 32,
  entryBody: 20_000,
  reportBody: 40_000,
  reportType: 32,
} as const;
